import React, { useEffect, useState } from "react";
import { FormControl, TextField } from "@mui/material";
import localize from "../../common/localize";
import { getInputLabelProps, getInputProps } from "../../common/appStyles";
import { MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION } from "../../common/utils";
import CreatedByText from "./CreatedByText";

export default function AddOrEditBasicEntity({
  model,
  setModel,
  hideDescription,
  codeFieldText,
  customComponent,
  customComponentAtTop,
  nameMandatory,
  codeMandatory,
  customWidth,
  isReadonly,
}) {
  const [descriptionCount, setDescriptionCount] = useState(0);
  const maximumCharactersForDescription =
    MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION;

  useEffect(() => {
    if (!hideDescription && model.Description) {
      setDescriptionCount(model.Description.length);
    }
  }, [model?.Description]);

  const handleChange = (e) => {
    setModel({
      ...model,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div style={{ width: customWidth ?? "500px", height: "100%" }}>
      <form className="w-full h-full">
        {customComponentAtTop && customComponent && customComponent}

        <div className="flex-col flex-wrap mb-6 w-full">
          <FormControl
            required
            fullWidth
            sx={{ width: "100%", marginTop: "5px" }}
          >
            <TextField
              sx={{ width: "100%" }}
              required={nameMandatory}
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              id="outlined-basic"
              name="Name"
              label={localize.name}
              variant="outlined"
              onChange={isReadonly ? undefined : handleChange}
              value={model.Name}
            />
          </FormControl>

          {codeFieldText && (
            <div className="mt-3 w-full">
              <FormControl required fullWidth sx={{ width: "100%" }}>
                <TextField
                  sx={{ width: "100%" }}
                  required={codeMandatory}
                  InputLabelProps={getInputLabelProps()}
                  inputProps={getInputProps()}
                  size="small"
                  fullWidth
                  id="outlined-basic"
                  name="Code"
                  label={codeFieldText}
                  variant="outlined"
                  onChange={isReadonly ? undefined : handleChange}
                  value={model.Code}
                />
              </FormControl>
            </div>
          )}
        </div>

        {!hideDescription && (
          <div className="flex flex-wrap mb-3 w-full">
            <FormControl required fullWidth sx={{ width: "100%" }}>
              <TextField
                sx={{ width: "100%" }}
                InputLabelProps={getInputLabelProps()}
                inputProps={{
                  style: {
                    fontSize: "0.8em",
                  },
                  maxLength: maximumCharactersForDescription,
                }}
                size="small"
                fullWidth
                multiline
                rows={3}
                id="outlined-basic"
                name="Description"
                label={localize.description}
                variant="outlined"
                onChange={isReadonly ? undefined : handleChange}
                value={model.Description}
                helperText={`${descriptionCount}/${maximumCharactersForDescription}`}
              />
            </FormControl>
          </div>
        )}

        {!customComponentAtTop && customComponent && customComponent}

        <CreatedByText entity={model} />
      </form>
    </div>
  );
}
